import InitApi from "api/InitApi";
import { useInfiniteQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import useUserIp from "hooks/useUserIp";
import { deleteEmptyObjects, fetchConfig } from "utils";

export const BOOKS_PAGE_SIZE = 30;

const readBooksPage = (payload, pageParam) => {
	const data = payload?.data;

	if (!data) {
		return {
			records: [],
			totalRecords: 0,
			currentPage: pageParam,
			hasMorePages: false,
		};
	}

	return {
		records: data.records || [],
		totalRecords: data.total_records || 0,
		currentPage: data.current_page || pageParam,
		hasMorePages: Boolean(data.has_more_pages),
	};
};

export const flattenBooks = (data) => {
	const pages = data?.pages || [];
	const seen = new Set();
	const books = [];

	pages.forEach((page) => {
		(page.records || []).forEach((book) => {
			if (book?.id == null || seen.has(book.id)) return;
			seen.add(book.id);
			books.push(book);
		});
	});

	return books;
};

/**
 * @param {Record<string, unknown>} queryParams Filter/search params (without page).
 */
const useInfiniteBooks = (queryParams = {}) => {
	const { accessToken } = useTokenStore();
	const { userIp } = useUserIp();

	const fetchPage = async ({ pageParam = 1 }) => {
		const instance = await InitApi({ accessToken, userIp });
		const params = deleteEmptyObjects({
			...queryParams,
			page: pageParam,
			rows_per_page: BOOKS_PAGE_SIZE,
		});

		const res = await instance.get("books", { params });
		return readBooksPage(res.data, pageParam);
	};

	return useInfiniteQuery(["books", "infinite", queryParams], fetchPage, {
		...fetchConfig,
		getNextPageParam: (lastPage) => (lastPage?.hasMorePages ? lastPage.currentPage + 1 : undefined),
		keepPreviousData: true,
	});
};

export default useInfiniteBooks;
